(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-tab"] && !Shopify.designMode) return;
  try {
    
  'use strict';

function Tabs() {
  
  var bindAll = function() {
    var menuElements = document.querySelectorAll('[data-tabbtn]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].addEventListener('click', change, false);
    }
    defaultTabs();
  }
  var defaultTabs = function() {
    var str = window.location.href;
    var current = str.slice(str.indexOf('#') + 1);
    console.log(current);
if(current.indexOf("content") !== -1){
      console.log("contiene");
      document.getElementById(current).classList.add('active');
    }else{
       console.log("noncontiene");
      var menuElements = document.querySelectorAll('[data-tabbtn]');
        menuElements[0].classList.add('active');
        var id = menuElements[0].getAttribute('data-tabbtn');
        document.getElementById(id).classList.add('active');
      }
  }

  var clear = function() {
    var menuElements = document.querySelectorAll('[data-tabbtn]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].classList.remove('active');
      var id = menuElements[i].getAttribute('data-tabbtn');
      document.getElementById(id).classList.remove('active');
    }
  }

  var change = function(e) {
    clear();
    e.target.classList.add('active');
    var id = e.currentTarget.getAttribute('data-tabbtn');
    document.getElementById(id).classList.add('active');
    // setTimeout(function() {window.scrollTo(0, 0);}, 1);
  }
  bindAll();
  if(window.location.href.indexOf("content-ec9efed2-f16c-40fb-abc7-18d0171668ed") > -1) {
      clear();
      var menuElements = document.querySelectorAll('[data-tabbtn]');
    menuElements[1].classList.add('active');
      var id = menuElements[1].getAttribute('data-tabbtn');
      document.getElementById('content-ec9efed2-f16c-40fb-abc7-18d0171668ed').classList.add('active');
    }
}
var connectTabs = new Tabs();


  } catch(e) { console.error(e); }
})();
})();
